import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";
import { InterviewScene } from "./InterviewScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.Collage;
        this.howToPlayScene = InterviewScene;
        this.introTextKeys = [
            "Collage.Phaser.IntroductionScene.3",
            "Collage.Phaser.IntroductionScene.4",
            "Collage.Phaser.IntroductionScene.5",
            "Collage.Phaser.IntroductionScene.1",
            "Collage.Phaser.IntroductionScene.2",
            "Collage.Phaser.IntroductionScene.6",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/CollageGame/scenes/GameIntro.ts